import { render, staticRenderFns } from "./GraphDetail32.vue?vue&type=template&id=35d468ce&scoped=true"
import script from "./GraphDetail32.vue?vue&type=script&lang=js"
export * from "./GraphDetail32.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d468ce",
  null
  
)

export default component.exports